import { useState, useEffect } from "react"
import { v4 as uuidv4 } from "uuid"
import { loadTossPayments, ANONYMOUS } from "@tosspayments/tosspayments-sdk"

import useGetAccount from "entity/account/useGetAccount"

import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useTosspayments = (amount, orderName, callbackUrl) => {
    const [widgets, setWidgets] = useState(null)
    const [paymentMethodWidget, setPaymentMethodWidget] = useState(null)
    const [agreementWidget, setAgreementWidget] = useState(null)

    const [getAccount] = useGetAccount()

    const [, setAlert] = useAlertModalAtom()


    // 결제위젯 불러오기
    useEffect(() => {
        const initTosspayments = async () => {
            try {
                const tosspayments = await loadTossPayments(process.env.REACT_APP_TOSSPAYMENTS_CLIENT)
                setWidgets(tosspayments.widgets({
                    "customerKey": ANONYMOUS
                }))
            } catch (err) {
                setAlert("결제위젯을 불러오는데 실패했습니다.")
            }
        }
        initTosspayments()
    }, [])

    useEffect(() => {

        // 결제위젯 랜더링
        const renderWidget = async () => {
            if (!widgets) return

            try {
                await widgets.setAmount({ "currency": "KRW", "value": amount })   // 결제 금액 설정
                setPaymentMethodWidget(await widgets.renderPaymentMethods({ "selector": "#payment-method", "variantKey": "DEFAULT", }))   // 결제창 랜더링
                setAgreementWidget(await widgets.renderAgreement({ "selector": "#agreement", "variantKey": "AGREEMENT" }))   // 약관 랜더링
            } catch (err) {
                console.log(err)
                setAlert("결제위젯 랜더링에 실패했습니다.")
            }
        }
        renderWidget()

        // 리랜더링 될 때 결제창 초기화
        return () => {
            if (paymentMethodWidget) {
                paymentMethodWidget.destroy()
                setPaymentMethodWidget(null)
            }
            if (agreementWidget) {
                agreementWidget.destroy()
                setAgreementWidget(null)
            }
            setAlert(null)
        };
    }, [widgets])

    // 결제하기 이벤트
    const clickPaymentEvent = async () => {

        if (!getAccount) {
            setAlert("사용자 계정 정보를 찾을 수 없습니다.")
            return
        }

        try {
            await widgets.requestPayment({
                "orderId": uuidv4(),
                "orderName": orderName,
                "successUrl": `${window.location.origin}/payment/${callbackUrl}`,
                "failUrl": `${window.location.origin}/payment/fail`,
                "customerName": getAccount?.data?.name,
                "customerMobilePhone": getAccount?.data?.contact
            })
        } catch (err) {
            console.log(err)
            setAlert("결제 요청에 실패했습니다.")
        }
    }

    return [clickPaymentEvent]
}

export default useTosspayments